import React from "react";
import { Collapse, Typography } from "antd";
import { observer } from "mobx-react";
import { getCalculatedPercentage } from "utils/adminUsageDetail/dashboardUtils";
import AppTable from "components/AppTable/AppTable";
import { tableColumns } from "utils/adminUsageDetail/tableColumns";

const UsageAccordion = ({ activeKeys, onCollapseChange, adminGatewayStore, userId, month, year, adminTableLoading, dedicatedNumbersLoading, purchaseData, oldPurchaseData }) => {
  const purchaseOrdersPaginationConfig = {
    defaultCurrent: 1,
    current: adminGatewayStore.purchaseOrdersPagination.current,
    total: adminGatewayStore.purchaseOrdersPagination.total,
    pageSize: adminGatewayStore.purchaseOrdersPagination.pageSize,
    onChange: current => {
      adminGatewayStore.setPurchaseOrdersPage(current, { current, userId, month, year });
    },
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => {
      adminGatewayStore.setPurchaseOrdersPageSize(pageSize, {
        userId,
        type: "usage",
        month,
        year
      });
    },
    className: "float-start",
    hideOnSinglePage: true,
    showQuickJumper: true
  };

  const senderIdsPaginationConfig = {
    defaultCurrent: 1,
    current: adminGatewayStore.senderIdsPagination.current,
    total: adminGatewayStore.senderIdsPagination.total,
    pageSize: adminGatewayStore.senderIdsPagination.pageSize,
    onChange: current => {
      adminGatewayStore.setSenderIdsPage(current, {
        userId,
        type: "usage",
        month,
        year
      });
    },
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => {
      adminGatewayStore.setSenderIdsPageSize(pageSize, {
        userId,
        type: "usage",
        month,
        year
      });
    },
    className: "float-start",
    hideOnSinglePage: true,
    showQuickJumper: true
  };

  // Helper function to get purchase data by type
  const getPurchaseDataByType = type => {
    const current = purchaseData.find(item => item._id === type);
    const previous = oldPurchaseData.find(item => item._id === type);

    const currentAmount = current ? (current.totalPurchases / 100).toFixed(2) : "0.00";
    const percentage = getCalculatedPercentage(current?.totalPurchases || 0, previous?.totalPurchases || 0);

    return {
      purchase: `AUD ${currentAmount}`,
      graph: `${percentage > 0 ? "+" : ""}${percentage.toFixed(2)}%`
    };
  };

  const adminData = getPurchaseDataByType("ADMIN");

  const accordionData = [
    {
      key: "1",
      title: "VIRTUAL_NUMBER",
      disabled: false,
      showArrow: true,
      showStats: false,
      content: (
        <AppTable
          loading={dedicatedNumbersLoading}
          columns={tableColumns.getDedicatedNumberColumns()}
          dataSource={adminGatewayStore.userSenderIdsUsageList}
          pagination={senderIdsPaginationConfig}
          bordered
          rowKey="number"
          scroll={{ x: 750 }}
        />
      )
    },
    {
      key: "2",
      title: "ADMIN",
      purchase: adminData.purchase,
      graph: adminData.graph,
      disabled: false,
      showArrow: true,
      content: (
        <AppTable
          loading={adminTableLoading}
          columns={tableColumns.getAdminColumns()}
          dataSource={adminGatewayStore.userPurchaseOrdersList || []}
          pagination={purchaseOrdersPaginationConfig}
          bordered
          rowKey={record => record._id}
          scroll={{ x: 750 }}
        />
      )
    }
  ];

  return (
    <div className="my-4">
      <Collapse activeKey={activeKeys} onChange={onCollapseChange}>
        {accordionData?.map(item => (
          <Collapse.Panel
            key={item.key}
            disabled={item.disabled}
            showArrow={item.showArrow}
            header={
              <div className="d-flex justify-content-between align-items-center pe-4 w-100">
                <Typography.Text strong>{item.title}</Typography.Text>
                {item.showStats !== false && (
                  <div className="d-flex gap-4">
                    <div className="text-center">
                      <div className="text-muted small">Purchase</div>
                      <strong>{item.purchase}</strong>
                    </div>
                  </div>
                )}
              </div>
            }
          >
            {item.content}
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default observer(UsageAccordion);
